import { createSlice } from "@reduxjs/toolkit";
import { getMemberSubscriptions, getSubscriptions } from "./_subscriptionAction";

const initialState: any = {
  data: [],
  subscriptions:[],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const subscriptionList = createSlice({
  name: "subscriptionList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getSubscriptions.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getSubscriptions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getSubscriptions.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
      .addCase(getMemberSubscriptions.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getMemberSubscriptions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.subscriptions = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getMemberSubscriptions.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
